import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Select,
  Text,
  VStack
} from '@chakra-ui/react';
import { Market, Selection } from '../../types/marketTypes';

interface MarketSettlementDialogProps {
  isOpen: boolean;
  onClose: () => void;
  market: Market;
  onSettle: (marketId: number, winningOutcomeId: number) => Promise<void>;
  isLoading: boolean;
}

export const MarketSettlementDialog: React.FC<MarketSettlementDialogProps> = ({
  isOpen,
  onClose,
  market,
  onSettle,
  isLoading
}) => {
  const [selectedOutcomeId, setSelectedOutcomeId] = useState<number | ''>('');

  const handleSubmit = async () => {
    if (selectedOutcomeId === '') return;
    
    await onSettle(market.id, Number(selectedOutcomeId));
    onClose();
    setSelectedOutcomeId('');
  };

  const handleClose = () => {
    setSelectedOutcomeId('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Settle Market</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>
              Please select the winning outcome for the market:
              <Text as="span" fontWeight="bold"> {market.name}</Text>
            </Text>
            <FormControl isRequired>
              <FormLabel>Winning Outcome</FormLabel>
              <Select
                placeholder="Select winning outcome"
                value={selectedOutcomeId}
                onChange={(e) => setSelectedOutcomeId(e.target.value ? Number(e.target.value) : '')}
              >
                {market.selections.map((selection: Selection) => (
                  <option key={selection.id} value={selection.id}>
                    {selection.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose} isDisabled={isLoading}>
            Cancel
          </Button>
          <Button 
            colorScheme="green" 
            onClick={handleSubmit} 
            isDisabled={selectedOutcomeId === '' || isLoading}
            isLoading={isLoading}
          >
            Settle Market
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
